/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditNewScorecardRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.new-scorecard',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditNewScorecardRoute);
